import { LegalPage, LegalSection, LEGAL } from "./LegalLayout";

export default function AvisoLegal() {
  return (
    <LegalPage subtitle="Legal" title="Aviso Legal">
      <LegalSection title="1. Datos identificativos">
        <p>En cumplimiento del artículo 10 de la Ley 34/2002, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se informa de los datos del titular de este sitio web:</p>
        <ul className="list-none space-y-1">
          <li><strong className="text-zinc-200">Titular:</strong> {LEGAL.razon}</li>
          <li><strong className="text-zinc-200">CIF:</strong> {LEGAL.cif}</li>
          <li><strong className="text-zinc-200">Domicilio social:</strong> {LEGAL.domicilio}</li>
          <li><strong className="text-zinc-200">Datos registrales:</strong> {LEGAL.registro}</li>
          <li><strong className="text-zinc-200">Email:</strong> <a className="text-[#D4AF37]" href={`mailto:${LEGAL.email}`}>{LEGAL.email}</a></li>
          <li><strong className="text-zinc-200">Teléfono:</strong> {LEGAL.telefono}</li>
          <li><strong className="text-zinc-200">Actividad:</strong> asesoría fiscal, contable, laboral y mercantil.</li>
        </ul>
      </LegalSection>

      <LegalSection title="2. Objeto">
        <p>El presente aviso legal regula el uso del sitio web de {LEGAL.marca}. La navegación por el sitio atribuye la condición de usuario e implica la aceptación de las condiciones aquí recogidas.</p>
      </LegalSection>

      <LegalSection title="3. Propiedad intelectual e industrial">
        <p>Todos los contenidos del sitio (textos, imágenes, marcas, logotipos, diseño y código) son titularidad de {LEGAL.razon} o de terceros que han autorizado su uso, y están protegidos por la normativa de propiedad intelectual e industrial. Queda prohibida su reproducción, distribución o transformación sin autorización expresa.</p>
      </LegalSection>

      <LegalSection title="4. Condiciones de uso y responsabilidad">
        <p>El usuario se compromete a hacer un uso adecuado de los contenidos y servicios del sitio y a no emplearlos para actividades ilícitas. {LEGAL.marca} no se hace responsable de los daños derivados de un uso indebido del sitio ni de las interrupciones que puedan producirse por causas ajenas a su control.</p>
      </LegalSection>

      <LegalSection title="5. Enlaces">
        <p>El sitio puede contener enlaces a páginas de terceros. {LEGAL.marca} no asume responsabilidad alguna sobre los contenidos o servicios de dichas páginas.</p>
      </LegalSection>

      <LegalSection title="6. Legislación aplicable y jurisdicción">
        <p>Este aviso legal se rige por la legislación española. Para la resolución de cualquier controversia, las partes se someten a los Juzgados y Tribunales del domicilio del titular, salvo que la normativa aplicable disponga otro fuero.</p>
      </LegalSection>
    </LegalPage>
  );
}
